(function(){
  // ---------- Kart Boat email signup: Shopify-native submit + reliable in-place success ----------
  var KB_PENDING_KEY='kb_prelaunch_pending_form';
  var KB_JOINED_KEY='kb_prelaunch_joined';
  var KB_TRACK_KEY='kb_prelaunch_lead_tracked';
  var KB_TIKTOK_TRACK_KEY='livvolt_tiktok_signup_tracked';
  var KB_TIKTOK_PIXEL_ID='DACD8GBC77U96JCOJUPG';

  function kbSource(){
    var p=new URLSearchParams(window.location.search);
    return p.get('utm_source')||p.get('source')||(document.referrer?'referral':'organic');
  }

  function fireKbMetaLead(){
    try{
      if(typeof window.fbq==='function'){
        window.fbq('track','Lead',{
          content_name:'Kart Boat Pre-launch',
          content_category:'Kickstarter Pre-launch',
          source:kbSource()
        });
        return true;
      }
    }catch(e){}
    return false;
  }

  function ensureKbTikTokPixel(){
    if(window.ttq&&typeof window.ttq.track==='function') return true;
    try{
      (function(w,d,t){
        w.TiktokAnalyticsObject=t;
        var ttq=w[t]=w[t]||[];
        ttq.methods=['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie','holdConsent','revokeConsent','grantConsent'];
        ttq.setAndDefer=function(obj,method){obj[method]=function(){obj.push([method].concat(Array.prototype.slice.call(arguments,0)));};};
        for(var i=0;i<ttq.methods.length;i++) ttq.setAndDefer(ttq,ttq.methods[i]);
        ttq.instance=function(id){var inst=ttq._i[id]||[];for(var j=0;j<ttq.methods.length;j++)ttq.setAndDefer(inst,ttq.methods[j]);return inst;};
        ttq.load=function(id,opts){
          var src='https://analytics.tiktok.com/i18n/pixel/events.js';
          ttq._i=ttq._i||{};ttq._i[id]=[];ttq._i[id]._u=src;
          ttq._t=ttq._t||{};ttq._t[id]=+new Date;
          ttq._o=ttq._o||{};ttq._o[id]=opts||{};
          var s=d.createElement('script');s.type='text/javascript';s.async=true;
          s.src=src+'?sdkid='+id+'&lib='+t;
          var first=d.getElementsByTagName('script')[0];first.parentNode.insertBefore(s,first);
        };
        ttq.load(KB_TIKTOK_PIXEL_ID);
        // Do not call ttq.page(): Shopify's TikTok app already sends PageView.
      })(window,document,'ttq');
    }catch(e){ return false; }
    return !!(window.ttq&&typeof window.ttq.track==='function');
  }

  function fireKbTikTokRegistration(){
    try{
      // Only count a registration after the confirmed-success UI is present.
      if(!document.querySelector('.kb-ok, .kb-ok-sm')) return false;
      if(sessionStorage.getItem(KB_TIKTOK_TRACK_KEY)==='1') return true;
      if(!ensureKbTikTokPixel()) return false;
      window.ttq.track('CompleteRegistration',{
        content_name:'LIVVOLT Kart Boat Prelaunch Signup',
        source:kbSource()
      });
      sessionStorage.setItem(KB_TIKTOK_TRACK_KEY,'1');
      return true;
    }catch(e){}
    return false;
  }

  function fireKbPixels(){
    var metaSent=fireKbMetaLead();
    try{ if(typeof window.gtag==='function') window.gtag('event','sign_up',{method:'email',source:kbSource()}); }catch(e){}
    fireKbTikTokRegistration();
    return metaSent;
  }

  function setKbLoading(form,on){
    var btn=form&&form.querySelector('button[type="submit"]');
    if(!btn) return;
    if(on){
      if(btn.dataset.txt===undefined) btn.dataset.txt=btn.textContent;
      btn.textContent='JOINING…';
      btn.disabled=true;
      form.setAttribute('aria-busy','true');
    }else{
      if(btn.dataset.txt!==undefined) btn.textContent=btn.dataset.txt;
      btn.disabled=false;
      form.removeAttribute('aria-busy');
    }
  }

  function kbSuccessMarkup(form){
    if(form&&form.id==='kbFormHero'){
      return '<div class="kb-ok">✓ YOU’RE ON THE LIST</div>'+
        '<p class="kb-ok-sub">Thanks for joining LIVVOLT. Kickstarter launches September 20.</p>'+
        '<p class="kb-ok-sub">We’ll email you when the campaign goes live so you can be among the first to access the $6,199 Super Early Bird — only 5 available, with $699 in bonus gear.</p>'+
        '<button type="button" class="btn btn-ghost btn-lg kb-explore" data-explore>EXPLORE THE KART BOAT ↓</button>';
    }
    return '<div class="kb-ok-sm">✓ YOU’RE ON THE LIST · See you September 20.</div>';
  }

  function showKbSuccess(form){
    if(!form) return;
    var msg=form.parentElement.querySelector('[data-msg]')||form.querySelector('[data-msg]');
    form.style.display='none';
    form.removeAttribute('aria-busy');
    if(form.parentElement) form.parentElement.classList.add('kb-slot-success');
    if(msg){
      msg.className='form-msg ok';
      msg.innerHTML=kbSuccessMarkup(form);
    }
    if(form.id==='kbFormHero'){
      var hero=form.closest('.hero');
      if(hero) hero.classList.add('kb-signup-success');
      // Make the confirmation itself the focus target without triggering a scroll.
      var ok=msg&&msg.querySelector('.kb-ok');
      if(ok){ ok.setAttribute('tabindex','-1'); }
    }
    var ex=msg&&msg.querySelector('[data-explore]');
    if(ex){
      ex.addEventListener('click',function(){
        var t=document.getElementById('film');
        if(t) t.scrollIntoView({behavior:'smooth',block:'start'});
      });
    }
  }

  function markKbJoinedUI(){
    var hero=document.getElementById('kbFormHero');
    var offer=document.getElementById('kbFormOffer');
    var finalForm=document.getElementById('kbFormFinal');

    // Hero gets the full success treatment requested for the pre-launch funnel.
    showKbSuccess(hero);
    // Lower-page forms become a compact confirmation instead of asking twice.
    showKbSuccess(offer);
    showKbSuccess(finalForm);

    document.querySelectorAll('[data-cta]').forEach(function(b){
      b.textContent='✓ YOU’RE ON THE LIST';
      b.classList.add('done');
      b.disabled=true;
      b.setAttribute('aria-disabled','true');
    });
  }

  function scrollHeroAfterSuccess(){
    var hero=document.getElementById('top');
    if(!hero) return;

    // Shopify / mobile browsers may perform their own fragment scroll AFTER this
    // section script has already run. Remove the hash first, disable restoration,
    // then re-assert the Hero position through the full page-load lifecycle.
    try{
      if('scrollRestoration' in history) history.scrollRestoration='manual';
      if(window.location.hash && history.replaceState){
        history.replaceState(null,document.title,window.location.pathname+window.location.search);
      }
    }catch(e){}

    var go=function(){
      var y=hero.getBoundingClientRect().top+window.pageYOffset;
      window.scrollTo(0,Math.max(0,y));
    };

    go();
    requestAnimationFrame(function(){ requestAnimationFrame(go); });
    [80,220,500,900,1500,2400].forEach(function(ms){ setTimeout(go,ms); });

    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',go,{once:true});
    }
    window.addEventListener('load',go,{once:true});
    window.addEventListener('pageshow',go,{once:true});
  }

  function suppressDuplicateThemeNewsletterSuccess(){
    // A successful Shopify customer form can make Dawn's footer newsletter render
    // its generic success message as well. Hide that duplicate; the Kart Boat Hero
    // confirmation is the source of truth for this funnel.
    document.querySelectorAll('.newsletter-form__message--success, footer .form__message, .footer .form__message').forEach(function(el){
      var txt=(el.textContent||'').trim();
      if(/thanks for subscribing/i.test(txt)) el.style.display='none';
    });
  }

  function handleForm(form){
    if(!form) return;
    var msg=form.parentElement.querySelector('[data-msg]')||form.querySelector('[data-msg]');

    form.addEventListener('submit',function(e){
      var input=form.querySelector('input[type="email"]');
      var val=(input&&input.value||'').trim();
      var ok=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
      if(!ok){
        e.preventDefault();
        if(msg){ msg.textContent='Please enter a valid email address.'; msg.className='form-msg err'; }
        setKbLoading(form,false);
        return;
      }

      try{
        sessionStorage.setItem(KB_PENDING_KEY,form.id);
        // A genuine new submission must be allowed to emit a fresh Lead event.
        // Returning visitors do not reach this path, so this does not create duplicate Leads on refresh.
        sessionStorage.removeItem(KB_TRACK_KEY);
        sessionStorage.removeItem(KB_TIKTOK_TRACK_KEY);
      }catch(err){}
      setKbLoading(form,true);

      // IMPORTANT: native submit only. Shopify attaches hCaptcha to this form.
      // Do not preventDefault(), fetch(), form.submit(), or rewrite form.action.
    });
  }

  document.querySelectorAll('.email-form').forEach(handleForm);

  // ---------- Resolve Shopify native success deterministically (v5) ----------
  // Important: Shopify may preserve return_to's hash while dropping custom query
  // parameters. Therefore the primary signal is:
  //   1) this tab has a pending Kart Boat form submission in sessionStorage, AND
  //   2) Shopify returned us to that form's dedicated hash.
  // Server success markers / contact_posted remain fallbacks.
  var kbResolvedSuccess=false;

  function kbPendingFormId(){
    try{ return sessionStorage.getItem(KB_PENDING_KEY)||''; }catch(e){ return ''; }
  }

  function kbFromFormId(id){
    if(id==='kbFormOffer') return 'offer';
    if(id==='kbFormFinal') return 'final';
    return 'hero';
  }

  function kbHashForFormId(id){
    if(id==='kbFormOffer') return '#kbOfferSignup';
    if(id==='kbFormFinal') return '#kbFinalSignup';
    if(id==='kbFormHero') return '#kbHeroSignup';
    return '';
  }

  function kbThemeNewsletterSaysSuccess(){
    var els=document.querySelectorAll('.newsletter-form__message--success, footer .form__message, .footer .form__message');
    for(var i=0;i<els.length;i++){
      if(/thanks for subscribing/i.test((els[i].textContent||'').trim())) return true;
    }
    return false;
  }

  function kbCleanSuccessUrl(){
    // Remove Shopify/contact hashes after the success UI has replaced the form.
    // Keep useful UTM/source query parameters. Do NOT scroll.
    try{
      var u=new URL(window.location.href);
      u.searchParams.delete('contact_posted');
      history.replaceState(null,document.title,u.pathname+(u.searchParams.toString()?('?'+u.searchParams.toString()):''));
    }catch(e){}
  }

  function kbCompleteSignupSuccess(from){
    if(kbResolvedSuccess) return;
    kbResolvedSuccess=true;

    try{
      localStorage.setItem(KB_JOINED_KEY,'1');
      sessionStorage.removeItem(KB_PENDING_KEY);
    }catch(e){}

    // FIRST replace the exact form position with the confirmation.
    // We intentionally perform NO scrollIntoView/window.scrollTo here. Shopify has
    // already returned to the form anchor, so moving the viewport again caused the
    // previous 'slides down to Campaign Film' behavior.
    document.body.classList.add('kb-kart-joined');
    markKbJoinedUI();
    suppressDuplicateThemeNewsletterSuccess();

    try{
      if(sessionStorage.getItem(KB_TRACK_KEY)!=='1'){
        // GA4 and TikTok fire once after Shopify confirms success.
        // Meta is marked as tracked only after fbq is actually available and called.
        var metaSent=fireKbPixels();
        if(metaSent){
          sessionStorage.setItem(KB_TRACK_KEY,'1');
        }else{
          [500,1500,3000,6000].forEach(function(delay){
            setTimeout(function(){
              try{
                if(sessionStorage.getItem(KB_TRACK_KEY)==='1') return;
                if(fireKbMetaLead()) sessionStorage.setItem(KB_TRACK_KEY,'1');
              }catch(err){
                fireKbMetaLead();
              }
            },delay);
          });
        }
      }
    }catch(e){ fireKbPixels(); }

    // TikTok may finish loading after Shopify's success state is rendered.
    // Retry briefly, with its own session key preventing duplicate registrations.
    fireKbTikTokRegistration();
    [500,1500,3000,6000].forEach(function(delay){
      setTimeout(fireKbTikTokRegistration,delay);
    });

    // Clear the hash immediately after DOM replacement so the browser cannot perform
    // a second delayed fragment jump on mobile. This does not change scroll position.
    requestAnimationFrame(function(){
      requestAnimationFrame(kbCleanSuccessUrl);
    });
  }

  function resolveKbSignupState(){
    if(kbResolvedSuccess) return true;

    var pending=kbPendingFormId();
    var expectedHash=kbHashForFormId(pending);
    var returnedToPending=!!pending && !!expectedHash && window.location.hash===expectedHash;
    var serverSuccess=!!document.querySelector('[data-kb-server-success]');
    var urlSuccess=/[?&]contact_posted=true/.test(window.location.search);
    var footerSuccess=!!pending && kbThemeNewsletterSaysSuccess();

    if(returnedToPending || serverSuccess || urlSuccess || footerSuccess){
      kbCompleteSignupSuccess(kbFromFormId(pending));
      return true;
    }
    return false;
  }

  // Resolve as early as possible, then once more at the normal browser lifecycle points.
  resolveKbSignupState();
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',resolveKbSignupState,{once:true});
  }
  window.addEventListener('load',resolveKbSignupState,{once:true});
  window.addEventListener('pageshow',resolveKbSignupState,{once:true});

  // Dawn can insert its footer success message after this section's script executes.
  // A short-lived observer gives us one final reliable fallback without polling forever.
  try{
    var kbObs=new MutationObserver(function(){
      if(resolveKbSignupState() || kbResolvedSuccess){ kbObs.disconnect(); }
    });
    kbObs.observe(document.documentElement,{childList:true,subtree:true});
    setTimeout(function(){ try{kbObs.disconnect();}catch(e){} },3000);
  }catch(e){}

  var kbKnownJoined=false;
  try{ kbKnownJoined=localStorage.getItem(KB_JOINED_KEY)==='1'; }catch(e){}
  if(!kbResolvedSuccess && kbKnownJoined){
    // Returning visitor on this device: show joined UI without forcing a scroll.
    document.body.classList.add('kb-kart-joined');
    markKbJoinedUI();
    suppressDuplicateThemeNewsletterSuccess();
  }


})();
